import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import Constants from '../../../definitions/constants';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import LocaleTooling from '../../../tooling/localeTooling';

import GlassPopup from '../common/interface/glassPopup';
import ErrorFeedback from '../common/feedback/errorFeedback';
import Select from '../common/inputs/select';
import FieldInfo from '../common/inputs/fieldInfo';
import ExportBiReportsMultiModelSelector from './exportBiReportsMultiModelSelector';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';

const SelectBiTemplatesPopup = props => {
  const {    
    handleShowPopup,
    handleButton,
    handleOnChangeBiReportsSelectList, //function: Handles changes on the select list inside the popup (doesn't handle saving the info to the container)
    selectListValues, //array: Values of the select list inside the popup
    polynomialsData,
    biTemplatesData,
    popupState,
  } = props;
  return (
    <GlassPopup
      className="form_popup import_form_popup"
      title={(<FormattedMessage id="exportConfigurationsAdmin.selectBiObjectsPopup.title"/>)}
      buttonText={(<FormattedMessage id="exportConfigurationsAdmin.selectBiObjectsPopup.button"/>)}
      {...props}
    >
      <ExportBiReportsMultiModelSelector        
        values={selectListValues}
        onChange={handleOnChangeBiReportsSelectList}
        data-path="bi_data_list"
        addSelectLocale={<FormattedMessage id="exportConfigurationsAdmin.polynomialsSelectTitle"/>}
        labelLocale={<FormattedMessage id="exportConfigurationsAdmin.biTemplatesDataLabel"/>}
        noMoreOptionsLocale={intl.formatMessage({id: "exportConfigurationsAdmin.noMorePolynomialsSelectLocale"})}
        options={InterfaceTooling.getSelectArrayFromArrayOfObjects(polynomialsData, "id", "name")}
        biTemplatesData={biTemplatesData}
        valueAccesor={"model_id"}
        labelAccesor={"name"}
      /> 
    </GlassPopup>
  );
};

export default SelectBiTemplatesPopup;



// WEBPACK FOOTER //
// ./source/client/components/exportConfigurationsAdmin/selectBiTemplatesPopup.jsx